/**
 * Maps folder names from the API response to the { value, name } shape
 * expected by the provider options dropdowns.
 */
export function mapFoldersToCourses(folders) {
  return (folders || []).map((item) => ({
    value: item,
    name: item,
  }));
}

/**
 * Centralized error handler for store actions — logs, stores the error,
 * and resets loading flags.
 */
export function handleError(commit, error, context = "") {
  const errorMessage =
    error?.message || error || "An unexpected error occurred";
  console.error(context ? `[${context}]` : "[pragyaai]", errorMessage);
  commit("SET_CHAT_ERROR", errorMessage);
  commit("SET_IS_GENERATING_RESPONSE", false);
  commit("SET_IS_FETCHING_OPTIONS", false);
}

/**
 * Normalises resources from different providers into a consistent shape
 * for the Message component.
 */
export function processResources(resources, provider) {
  if (!resources || !Array.isArray(resources) || resources.length === 0) {
    return [];
  }

  const processed = [];
  const seen = new Set();

  resources.forEach((resource, i) => {
    let item;

    switch (provider) {
      case "aws":
        item = {
          id: resource.key || `aws-resource-${i}`,
          displayName:
            resource?.metadata?.filename ||
            (resources.length === 1 ? "Resource" : `Resource ${i + 1}`),
          key: resource.key,
          provider: "aws",
          metadata: resource.metadata || {},
          originalResource: resource,
        };
        break;

      case "vertex": {
        const name =
          resource.title?.trim() ||
          resource.uri?.split("/").pop()?.split("?")[0]?.trim() ||
          `Resource ${i + 1}`;
        if (seen.has(name)) return;
        seen.add(name);
        item = {
          id: resource.uri || resource.document || `vertex-resource-${i}`,
          displayName: name,
          uri: resource.uri,
          title: resource.title,
          content: resource.content,
          relevanceScore: resource.relevanceScore,
          document: resource.document,
          provider: "vertex",
          metadata: resource.structData || {},
          originalResource: resource,
        };
        break;
      }

      default:
        item = {
          id: resource.id || resource.key || `${provider}-resource-${i}`,
          displayName:
            resource.title || resource.name || `Resource ${i + 1}`,
          provider,
          originalResource: resource,
        };
    }

    if (item) processed.push(item);
  });

  return processed;
}
